// removed by extract-text-webpack-plugin
module.exports = {"trayWidget":"_2zeP"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Flows/Flow/TrayWidget/TrayWidget.scss
// module id = FHiA
// module chunks = 0